import React from 'react';
import * as Styled from './Section.styled';
import { StyledBackgroundContainer } from '../StyledBackgroundContainer.styled';

/**
 * At the moment, Section does not need SectionExternalDataProps.
 * Omitted because, in Typescript, empty interfaces accept any non-nullable value.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `Section` container logically groups content. A `Section` block can only be
 * the child of a `Layout` block and it can contain 1-n `Element` blocks as children.
 */
export const Section = _ref => {
  let {
    cssJustifyContent,
    cssBackgroundColor,
    cssBackgroundColorOpacity,
    cssBackgroundImageOpacity,
    backgroundImagePreset,
    backgroundImageUrl,
    cssBorderColor,
    cssBorderWidth,
    cssBorderStyle,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(StyledBackgroundContainer, {
    cssBackgroundColor: cssBackgroundColor,
    cssBackgroundColorOpacity: cssBackgroundColorOpacity,
    cssBackgroundImageOpacity: cssBackgroundImageOpacity,
    backgroundImageUrl: backgroundImageUrl,
    backgroundImagePreset: backgroundImagePreset,
    children: /*#__PURE__*/_jsx(Styled.SectionContent, {
      cssJustifyContent: cssJustifyContent,
      cssBorderWidth: cssBorderWidth,
      cssBorderColor: cssBorderColor,
      cssBorderStyle: cssBorderStyle,
      isEmpty: React.Children.count(children) === 0,
      ...rest,
      children: children
    })
  });
};